import gql from "graphql-tag";

export const POLL_REPORT_STATUS = gql`
    query PollReportStatus($reportId:ID!, $exportId:ID!) {
        pollReportStatus(reportId:$reportId, exportId:$exportId) {
            id
            reportId
            status
            resourceLocation
        }
    }
`;

export const GENERATE_REPORT = gql`
    mutation GeneateReport($input: ReportParamsInput!) {
        geneateReport(input: $input) {
            id
            reportId
        }
    }
`;

